import request from '@/utils/request'
// 查询产品列表
export function getProductList(params) {
    return request({
      url: '/api/ros-shop-service/api/product/index/page',
      method: 'get',
      params
    })
  }
// 产品banner
export function getBannerList(params) {
    return request({
      url: '/api/ros-developer-service/front/content/product/top',
      method: 'get',
      params: params
    })
  }
// 产品详情
export function getProductDetail(params) {
    return request({
      url: '/api/ros-shop-service/api/product/detail',
      method: 'get',
      params: params
    })
  }
// 查询地址
export function getAddressList(params) {
    return request({
      url: '/api/ros-user-service/api/user/receive/address/list',
      method: 'get',
      params: params
    })
  }
  //添加地址
  export function addAddress(data) {
      return request({
        url:'/api/ros-user-service/api/user/receive/address/add',
        method: 'post',
        data
      })
    }
  //修改地址
  export function updateAddress(data) {
      return request({
        url:'/api/ros-user-service/api/user/receive/address/update',
        method: 'post',
        data
      })
    }
  //删除地址
  export function deleteAddress(id) {
      return request({
        url:`/api/ros-user-service/api/user/receive/address/del/${id}`,
        method: 'post',
      })
    }
  //用户收件地址设为默认
  export function defaultAddress(id) {
      return request({
        url:`/api/ros-user-service/api/user/receive/address/set/default/${id}`,
        method: 'post',
      })
    }
  //订单提交---立即支付
  export function orderNow(data) {
      return request({
        url:`/api/ros-shop-service/api/order/orderNow`,
        method: 'post',
        data
      })
    }
  //订单状态查询
  export function orderStatus(params) {
      return request({
        url:`/api/ros-shop-service/api/order/current/status`,
        method: 'get',
        params
      })
    }
  //重试支付以及订单中心提交订单支付
  export function payNow(data) {
      return request({
        url:`/api/ros-shop-service/api/order/payNow`,
        method: 'post',
        data
      })
    }
  //订单列表
  export function getOrderList(params) {
      return request({
        url:`/api/ros-shop-service/api/order/center/page`,
        method: 'get',
        params
      })
    }
  //取消订单
  export function cancelOrder(orderId) {
      return request({
        url:`/api/ros-shop-service/api/order/cancel/${orderId}`,
        method: 'post',
      })
    }
  //订单详情
  export function getOrderDetail(params) {
      return request({
        url:`/api/ros-shop-service/api/order/detail`,
        method: 'get',
        params
      })
    }
  //省市区地址
  export function getAddressLists(params) {
      return request({
        url:`/api/ros-shop-service/api/address/listAll`,
        method: 'get',
        params
      })
    }


